import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={`chapter-${number}`}>
    <span className="font-mono text-xs text-gold/80 tracking-widest">{number}</span>
    <span className="h-px w-12 bg-gold/40" />
    <span className="overline-tag">{label}</span>
  </div>
);
